﻿import $ from "./dQuery";

export default function (triggerSelector: string = '[dc-shelf-trigger]') {

    $(triggerSelector)
        .on('click', () => {
            $('.stage-shelf').toggleClass('hidden');
            $('.stage').toggleClass('stage-open');
        });
};